import { ref } from "vue";

type ToastType = "info" | "success" | "error";

interface Toast {
  id: number;
  message: string;
  type: ToastType;
}

// Module-level singleton so all callers share the same queue.
const toasts = ref<Toast[]>([]);
let nextId = 0;

export function useToast() {
  function show(message: string, type: ToastType = "info", duration = 4000): number {
    const id = ++nextId;
    toasts.value = [...toasts.value, { id, message, type }];
    if (duration > 0) setTimeout(() => dismiss(id), duration);
    return id;
  }

  function dismiss(id: number): void {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  }

  return { toasts, show, dismiss };
}
